/* Curiosa paketväljare (3 × 50 ml / 5 × 50 ml). Se sections/curiosa-bundle.liquid. */
(function () {
  var root = document.getElementById('c-bx');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';

  var labels = JSON.parse(root.querySelector('[data-bx-i18n]').textContent);
  var route = (root.dataset.root || '/').replace(/\/$/, '');
  function tr(key, values) { return (labels[key] || key).replace(/\{(\w+)\}/g, function (_, name) { return values && values[name] != null ? values[name] : ''; }); }

  var COUNT = parseInt(root.dataset.count, 10) || 3;
  var VARIANT = root.dataset.variant;
  var PRICE = root.dataset.price || '';
  var LABELS = (root.dataset.labels || '').split('|');
  var EXCLUDED = (root.dataset.excluded || '').split(',').filter(Boolean);
  function cartSectionId() {
    var drawer = document.querySelector('cart-drawer');
    var sec = drawer && drawer.closest('.shopify-section');
    return sec && sec.id ? sec.id.replace(/^shopify-section-/, '') : (root.dataset.cartSection || 'cart-drawer');
  }
  var FIVE_URL = root.dataset.fiveUrl || '';
  var STORE_KEY = 'c-bx:' + VARIANT;
  var WORDS = ['', 'en', 'två', 'tre', 'fyra', 'fem'];

  var sheet = root.querySelector('[data-bx-sheet]');
  var listEl = root.querySelector('[data-bx-list]');
  var countEl = root.querySelector('[data-bx-count]');
  var searchEl = root.querySelector('[data-bx-search]');
  var addBtn = root.querySelector('[data-bx-add]');
  var mainBtn = root.querySelector('[data-bx-main]');
  var scroller = root.querySelector('[data-bx-scroll]');

  var products = [];      // alla dofter (sammanslaget från kollektionerna)
  var byHandle = {};
  var picked = [];        // handles i valordning (dubbletter tillåtna)
  var activeSlot = -1;    // vald plats som nästa + ersätter (-1 = lägg till sist)
  var SAVE = root.dataset.save || '';
  var stickyEl = root.querySelector('[data-bx-sticky]');
  var stickyBtn = root.querySelector('[data-bx-main-sticky]');
  var filter = '';
  var query = '';
  var loaded = null;
  var params = new URLSearchParams(location.search);
  var replaceKey = params.get('replace') || '';

  /* ---------- data ---------- */

  function load() {
    if (loaded) return loaded;
    var handles = (root.dataset.collections || 'perfumes').split(',');
    function get(h, tries) {
      return fetch(route + '/collections/' + h + '?view=bundle-data', { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .catch(function () {
          if (tries > 0) return new Promise(function (ok) { setTimeout(ok, 1200); }).then(function () { return get(h, tries - 1); });
          return null;
        });
    }
    loaded = Promise.all(handles.map(function (h) { return get(h, 2); })).then(function (lists) {
      if (lists.every(function (l) { return !l || !l.length; })) {
        loaded = null;
        throw new Error('load');
      }
      lists = lists.map(function (l) { return l || []; });
      lists.forEach(function (list) {
        list.forEach(function (p) {
          if (byHandle[p.h] || EXCLUDED.indexOf(p.h) !== -1) return;
          p.key = norm([p.s, p.o, p.r, p.t].join(' '));
          byHandle[p.h] = p;
          products.push(p);
        });
      });
      [
        ['inspired-by-stronger-with-you', 'inspirerad-av-stronger-with-you-intensely-forever-two'],
        ['oasis', 'inspirerad-av-oajan-spicy-honey']
      ].forEach(function (aliases) {
        var primary = byHandle[aliases[0]] || byHandle[aliases[1]];
        if (!primary) return;
        var position = products.findIndex(function (p) { return aliases.indexOf(p.h) !== -1; });
        products = products.filter(function (p) { return aliases.indexOf(p.h) === -1; });
        products.splice(position, 0, primary);
        aliases.forEach(function (h) { byHandle[h] = primary; });
      });
      // Slutsålda sist, annars kollektionens ordning
      products = products.filter(function (p) { return p.a; }).concat(products.filter(function (p) { return !p.a; }));
      return products;
    });
    return loaded;
  }

  function norm(s) {
    return (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[’'´`]/g, '');
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
  }

  function genderLabel(g) {
    if (!g || !g.length) return '';
    if (g.indexOf('unisex') !== -1 || (g.indexOf('herr') !== -1 && g.indexOf('dam') !== -1)) return 'Unisex';
    return g[0] === 'herr' ? tr('men') : tr('women');
  }

  /* ---------- läge ---------- */

  function save() {
    try { sessionStorage.setItem(STORE_KEY, JSON.stringify(picked)); } catch (e) {}
  }

  function restore() {
    var pre = (params.get('preselect') || params.get('add') || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    var saved = [];
    try { saved = JSON.parse(sessionStorage.getItem(STORE_KEY) || '[]') || []; } catch (e) {}
    if (pre.length) {
      // Vid "Ändra dofter" (replace) gäller exakt varukorgens val. Annars läggs förvalet först och tidigare val behålls.
      if (replaceKey) return { pre: pre };
      return { pre: pre.concat(saved.filter(function (h) { return pre.indexOf(h) === -1; })) };
    }
    return { saved: saved };
  }

  function resolve(keys) {
    var out = [];
    keys.forEach(function (k) {
      if (out.length >= COUNT) return;
      var p = byHandle[k];
      if (!p) {
        var nk = norm(k).trim();
        p = products.find(function (x) { return norm(x.t).trim() === nk || norm(x.s).trim() === nk; });
      }
      if (p && p.a) out.push(p.h);
    });
    return out;
  }

  /* ---------- rendering ---------- */

  function slotHTML(i, p, where) {
    if (!p) {
      return '<button type="button" class="c-bx__slot' + (where === 'sheet' && i === picked.length && activeSlot < 0 ? ' is-next' : '') + '" data-bx-open data-slot="' + i + '">' +
        '<span class="c-bx__slot-plus" aria-hidden="true">+</span>' +
        '<span class="c-bx__slot-name">' + esc(tr('choose_slot', {n:i+1})) + '</span>' +
        '<span class="c-bx__slot-meta">50 ml</span></button>';
    }
    var active = where === 'sheet' && i === activeSlot;
    return '<div class="c-bx__slot is-filled' + (active ? ' is-active' : '') + '">' +
      '<button type="button" class="c-bx__slot-main" data-bx-slot="' + i + '" aria-pressed="' + active + '" aria-label="' + esc(tr('change', {name:p.s})) + '">' +
        (p.i ? '<img src="' + esc(p.i) + '" alt="" loading="lazy" width="90" height="90">' : '') +
        '<span class="c-bx__slot-name">' + esc(p.s) + '</span>' +
        '<span class="c-bx__slot-meta">' + (active ? tr('new_below') : (where === 'page' ? tr('change_scent') : '50 ml')) + '</span>' +
      '</button>' +
      '<button type="button" class="c-bx__slot-x" data-bx-remove="' + i + '" aria-label="' + esc(tr('remove', {name:p.s})) + '">×</button>' +
      '</div>';
  }

  function renderSlots() {
    root.querySelectorAll('[data-bx-slots]').forEach(function (wrap) {
      var where = wrap.dataset.bxSlots;
      var html = '';
      for (var i = 0; i < COUNT; i++) html += slotHTML(i, byHandle[picked[i]], where);
      wrap.innerHTML = html;
    });
  }

  function remaining(left) { return tr(left === 1 ? 'remaining_one' : 'remaining_many', {n:left}); }
  function mainLabel(n, left, full) {
    if (full) return tr(replaceKey ? 'update' : 'add', {price:PRICE});
    return n === 0 ? tr('choose', {n:COUNT}) : remaining(left);
  }
  function renderStatus() {
    var n=picked.length, left=COUNT-n, full=left<=0;
    root.querySelectorAll('[data-bx-counter]').forEach(function(el){el.textContent=tr('counter',{n:n,count:COUNT});});
    var status = full ? (activeSlot>=0 ? tr('replace_slot',{n:activeSlot+1}) : tr('all_selected',{count:COUNT})) : tr('progress',{n:n,count:COUNT,remaining:remaining(left)});
    var st=root.querySelector('[data-bx-status]'); if(st)st.textContent=status;
    var fs=root.querySelector('[data-bx-foot-status]'); if(fs)fs.textContent=full?tr('ready',{count:COUNT}):status;
    var bar=root.querySelector('[data-bx-progress]'); if(bar)bar.style.width=Math.min(100,n/COUNT*100)+'%';
    if(addBtn){addBtn.disabled=!full;addBtn.textContent=full?tr(replaceKey?'update':'add_all',{count:COUNT,price:PRICE}):remaining(left);}
    if(mainBtn&&mainBtn.dataset.state!=='busy'&&root.dataset.available!=='false')mainBtn.textContent=mainLabel(n,left,full)+(full?'':' →');
    if(stickyBtn&&stickyBtn.dataset.state!=='busy'&&root.dataset.available!=='false')stickyBtn.textContent=mainLabel(n,left,full)+(n===0?' · '+PRICE:'');
    var hint=root.querySelector('[data-bx-hint]');
    if(hint){hint.textContent=full?tr('hint_done',{count:COUNT})+(SAVE?tr('saved',{save:SAVE}):''):(n===0?tr('hint_empty',{count:COUNT}):remaining(left)+'.');hint.classList.toggle('is-done',full);}

    var five = root.querySelector('[data-bx-five]');
    if (five && FIVE_URL) {
      var hs = picked.join(',');
      five.href = FIVE_URL + (hs ? (FIVE_URL.indexOf('?') === -1 ? '?' : '&') + 'preselect=' + encodeURIComponent(hs) : '');
    }
  }

  function rowHTML(p) {
    var n = picked.filter(function (h) { return h === p.h; }).length;
    var full = picked.length >= COUNT && activeSlot < 0;
    var notes = (p.n || []).filter(Boolean).slice(0, 2);
    var tags = [genderLabel(p.g)].concat(notes).filter(Boolean).join(' · ');
    var heading = p.o || p.s;
    var sub = p.o ? esc(p.s) + ' · 50 ml' : '50 ml';
    var top = p.o ? tr('inspired') : tr('original');
    var btn = !p.a
      ? '<span class="c-bxr__soldout">' + esc(tr('sold_out')) + '</span>'
      : '<button type="button" class="c-bxr__add" data-bx-pick="' + esc(p.h) + '" ' + (full ? 'disabled' : '') + ' aria-label="' + esc(tr('add_scent',{name:p.s})) + '">+</button>';
    return '<li class="c-bxr' + (n ? ' is-picked' : '') + (p.a ? '' : ' is-soldout') + '">' +
      '<div class="c-bxr__img">' + (p.i ? '<img src="' + esc(p.i) + '" alt="" loading="lazy" width="90" height="110">' : '') + '</div>' +
      '<div class="c-bxr__body">' +
        '<p class="c-bxr__top">' + top + '</p>' +
        '<p class="c-bxr__name">' + esc(heading) + '</p>' +
        '<p class="c-bxr__sub">' + sub + '</p>' +
        (tags ? '<p class="c-bxr__tags">' + esc(tags) + '</p>' : '') +
        (n ? '<p class="c-bxr__picked">' + esc(tr('selected')) + '' + (n > 1 ? ' ×' + n : '') + '</p>' : '') +
        (p.d ? '<details class="c-bxr__more"><summary>' + esc(tr('read_scent')) + '</summary><p>' + esc(p.d) + '</p><a href="' + route + '/products/' + esc(p.h) + '" target="_blank" rel="noopener">' + esc(tr('scent_page')) + '</a></details>' : '') +
      '</div>' +
      '<div class="c-bxr__action">' + btn + '</div>' +
      '</li>';
  }

  function visible() {
    var q = norm(query).trim();
    return products.filter(function (p) {
      if (filter === 'unisex') {
        if (genderLabel(p.g) !== 'Unisex') return false;
      } else if (filter && (!p.g || p.g.indexOf(filter) === -1)) return false;
      if (q && p.key.indexOf(q) === -1) return false;
      return true;
    });
  }

  function renderList() {
    if (!products.length) return;
    var list = visible();
    countEl.textContent = tr(list.length===1?'one_shown':'many_shown',{n:list.length})+(picked.length>=COUNT&&activeSlot<0?tr('replace_hint'):'');
    listEl.innerHTML = list.length ? list.map(rowHTML).join('') : '<li class="c-bxs__empty">' + esc(tr('no_match')) + '</li>';
  }

  function renderAll() {
    renderSlots();
    renderStatus();
    renderList();
    save();
  }

  function showLoadError() {
    countEl.textContent = '';
    listEl.innerHTML = '<li class="c-bxs__empty">' + esc(tr('load_error')) + '<br><button type="button" class="c-bxs__retry" data-bx-retry>' + esc(tr('retry')) + '</button></li>';
  }

  /* ---------- väljaren ---------- */

  var lastFocus = null;
  function openSheet() {
    lastFocus = document.activeElement;
    sheet.hidden = false;
    document.documentElement.classList.add('c-bxs-open');
    requestAnimationFrame(function () { sheet.classList.add('is-open'); });
    load().then(function () { renderAll(); }).catch(showLoadError);
    setTimeout(function () { var c = sheet.querySelector('.c-bxs__close'); c && c.focus({ preventScroll: true }); }, 50);
  }

  function closeSheet() {
    activeSlot = -1;
    renderSlots();
    sheet.classList.remove('is-open');
    document.documentElement.classList.remove('c-bxs-open');
    setTimeout(function () { sheet.hidden = true; }, 220);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  /* ---------- varukorg ---------- */

  function addToCart() {
    if (picked.length < COUNT) { openSheet(); return; }
    var errorEl = root.querySelector('[data-bx-error]');
    if (errorEl) errorEl.hidden = true;
    var props = {};
    picked.forEach(function (h, i) { props[(LABELS[i] || ('Parfym ' + (i + 1))).trim()] = byHandle[h] ? byHandle[h].t : h; });
    props._handles = picked.join(',');

    var btns = [addBtn, mainBtn, stickyBtn];
    btns.forEach(function (b) { if (b) { b.dataset.state = 'busy'; b.disabled = true; b.textContent = tr('adding'); } });

    // Lägg till det nya paketet först. Den gamla raden (replace) tas bort eller minskas med ett först när tillägget lyckats,
    // så att kunden aldrig blir utan paket om något går fel.
    var oldKey = replaceKey;
    fetch(route + '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: VARIANT, quantity: 1, properties: props }] })
    }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Fel'); return j; });
    }).then(function () {
      if (!oldKey) return null;
      return fetch(route + '/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        var line = (cart.items || []).find(function (it) { return it.key === oldKey; });
        if (!line) return null;
        return fetch(route + '/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: oldKey, quantity: Math.max(0, line.quantity - 1) }) });
      });
    }).then(function () {
      return fetch(route + '/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates: {}, sections: cartSectionId() })
      });
    }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Fel'); return j; });
    }).then(function (res) {
      return fetch(route + '/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        cart.sections = res.sections || {};
        try { sessionStorage.setItem('c-bx:added', '1'); sessionStorage.removeItem(STORE_KEY); } catch (e) {}
        picked = [];
        replaceKey = '';
        if (history.replaceState) {
          params.delete('replace'); params.delete('preselect');
          var qs = params.toString();
          history.replaceState(null, '', location.pathname + (qs ? '?' + qs : ''));
        }
        closeSheet();
        document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart: cart } }));
        if (!document.querySelector('cart-drawer')) location.href = route + '/cart';
      });
    }).catch(function (err) {
      if (errorEl) { errorEl.textContent = err.message || tr('error'); errorEl.hidden = false; }
      document.dispatchEvent(new CustomEvent('toast:show', { detail: { message: err.message || tr('error'), tone: 'error' } }));
    }).then(function () {
      btns.forEach(function (b) { if (b) { delete b.dataset.state; if (b !== addBtn) b.disabled = root.dataset.available === 'false'; } });
      renderAll();
    });
  }

  /* ---------- händelser ---------- */

  root.addEventListener('click', function (e) {
    var t = e.target;
    var pick = t.closest('[data-bx-pick]');
    if (pick) {
      if (activeSlot >= 0 && activeSlot < picked.length) {
        picked[activeSlot] = pick.dataset.bxPick;
        activeSlot = -1;
      } else if (picked.length < COUNT) {
        picked.push(pick.dataset.bxPick);
      } else {
        return;
      }
      var y = scroller.scrollTop;
      renderAll();
      scroller.scrollTop = y;
      return;
    }
    var rm = t.closest('[data-bx-remove]');
    if (rm) {
      picked.splice(parseInt(rm.dataset.bxRemove, 10), 1);
      activeSlot = -1;
      var y2 = scroller.scrollTop;
      renderAll();
      scroller.scrollTop = y2;
      return;
    }
    var slotBtn = t.closest('[data-bx-slot]');
    if (slotBtn) {
      var idx = parseInt(slotBtn.dataset.bxSlot, 10);
      activeSlot = activeSlot === idx && !sheet.hidden ? -1 : idx;
      if (sheet.hidden) openSheet(); else { renderSlots(); renderStatus(); renderList(); }
      return;
    }
    var f = t.closest('[data-bx-filter]');
    if (f) {
      filter = f.dataset.bxFilter;
      root.querySelectorAll('[data-bx-filter]').forEach(function (b) { b.classList.toggle('is-active', b === f); });
      renderList();
      return;
    }
    if (t.closest('[data-bx-retry]')) {
      countEl.textContent = tr('loading');
      listEl.innerHTML = '';
      load().then(function () { renderAll(); }).catch(showLoadError);
      return;
    }
    if (t.closest('[data-bx-close]')) { closeSheet(); return; }
    if (t.closest('[data-bx-add]')) { addToCart(); return; }
    if (t.closest('[data-bx-main]') || t.closest('[data-bx-main-sticky]')) {
      if (picked.length >= COUNT) addToCart(); else { activeSlot = -1; openSheet(); }
      return;
    }
    if (t.closest('[data-bx-open]')) { activeSlot = -1; openSheet(); }
  });

  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-bx-open-sheet]');
    if (o) { e.preventDefault(); openSheet(); }
  });

  searchEl.addEventListener('input', function () { query = searchEl.value; renderList(); });

  /* ---------- knapp som följer med vid scroll ---------- */
  // Visas när den ordinarie knappen har scrollats förbi. Döljs när väljaren, menyn eller varukorgen är öppen (CSS).
  if (stickyEl && mainBtn && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      stickyEl.hidden = e.isIntersecting || e.boundingClientRect.top > 0;
    }).observe(mainBtn);
  }
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !sheet.hidden) closeSheet(); });

  /* ---------- start ---------- */

  var st = restore();
  if (st.pre || (st.saved && st.saved.length)) {
    load().then(function () {
      picked = resolve(st.pre || st.saved);
      renderAll();
      if (st.pre && params.get('open') !== '0' && (picked.length < COUNT || replaceKey)) openSheet();
    }).catch(function () { renderStatus(); });
  } else {
    renderStatus();
    var pre = function () { load().catch(function () {}); };
    if ('requestIdleCallback' in window) requestIdleCallback(pre); else setTimeout(pre, 1500);
  }
})();
